import React from "react";

import LoadingButton, { LoadingButtonProps } from "@mui/lab/LoadingButton";
import Box from "@mui/material/Box";

import { CALENDAR_PROVIDERS_BY_ID } from "@app/common/constants/providers";
import type { CalendarProviderId } from "@app/common/types/providerTypes";

const PROVIDER_HEIGHT: {
  [key in Exclude<
    CalendarProviderId,
    "zoom_calendar"
  >]: React.CSSProperties["height"];
} = {
  google_calendar: "32px",
  microsoft_graph_calendar: "40px",
};

interface CalendarButtonProps {
  providerId: Exclude<CalendarProviderId, "zoom_calendar">;
  onClick: (
    event: React.MouseEvent<HTMLButtonElement>,
    providerId: CalendarProviderId
  ) => void;
  sx?: LoadingButtonProps["sx"];
  loading?: LoadingButtonProps["loading"];
}

const CalendarButton = ({
  providerId,
  onClick,
  sx,
  loading,
}: CalendarButtonProps) => {
  const provider = CALENDAR_PROVIDERS_BY_ID[providerId];
  return (
    <LoadingButton
      variant="outlined"
      startIcon={
        <Box
          component="img"
          src={provider.icon}
          sx={{ height: PROVIDER_HEIGHT[providerId] }}
        />
      }
      sx={{
        color: "shades.neutral.700",
        fontSize: "1.125rem",
        width: "100%",
        height: "56px",
        padding: "8px 16px",
        border: (theme) => `2px solid ${theme.palette.shades.neutral[100]}`,
        "& .MuiButton-startIcon": {
          marginRight: "12px",
        },
        "&:hover": {
          border: (theme) => `2px solid ${theme.palette.shades.neutral[100]}`,
        },
        ...sx,
      }}
      onClick={(event) => onClick?.(event, provider.id)}
      loading={loading}
    >
      {provider.displayName}
    </LoadingButton>
  );
};

export default CalendarButton;
